import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const RemoveIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M0 8H16" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

RemoveIcon.displayName = 'RemoveIcon';
